import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partners\PeppolCheckInvoiceable::__invoke
* @see app/Http/Controllers/Partners/PeppolCheckInvoiceable.php
* @route '/api/peppol/check-invoiceable'
*/
const PeppolCheckInvoiceable = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PeppolCheckInvoiceable.url(options),
    method: 'post',
})

PeppolCheckInvoiceable.definition = {
    methods: ["post"],
    url: '/api/peppol/check-invoiceable',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Partners\PeppolCheckInvoiceable::__invoke
* @see app/Http/Controllers/Partners/PeppolCheckInvoiceable.php
* @route '/api/peppol/check-invoiceable'
*/
PeppolCheckInvoiceable.url = (options?: RouteQueryOptions) => {
    return PeppolCheckInvoiceable.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partners\PeppolCheckInvoiceable::__invoke
* @see app/Http/Controllers/Partners/PeppolCheckInvoiceable.php
* @route '/api/peppol/check-invoiceable'
*/
PeppolCheckInvoiceable.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PeppolCheckInvoiceable.url(options),
    method: 'post',
})

export default PeppolCheckInvoiceable